import { z } from 'zod/v4';
export enum Directives {
  ROUTE = 'route',
  REFRESH = 'refresh',
  DO_NOTHING = 'do_nothing',
}
const routeDataSchema = z.object({
  directive: z.literal(Directives.ROUTE),
  routing: z.object({
    entity_index: z.number(),
    step_id: z.string(),
  }),
});

const refreshDataSchema = z.object({
  directive: z.literal(Directives.REFRESH),
  message: z.string().nullable().optional(),
});

const doNothingDataSchema = z.object({
  directive: z.literal(Directives.DO_NOTHING),
});

export const actionDataSchema = z.discriminatedUnion('directive', [
  routeDataSchema,
  refreshDataSchema,
  doNothingDataSchema,
]);
export type ActionData = z.infer<typeof actionDataSchema>;
